module.exports = __webpack_public_path__ + "img/logo_vijitlab.f17776e4.png";